import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useNavigate } from "react-router-dom";
import { Phone, Mail } from 'lucide-react';
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const filters = [
  "Meal Combo",
  "Starter",
  "Main Course",
  "Decoration",
  "Entertainment",
  "Photographer",
];


const initialItems = [
  // Meal Combo
  {
    id: "item-1",
    name: "Veg Meal Combo",
    type: "Meal Combo",
    category: "VEG",
    price: 1200,
    quantity: 1,
    selected: false,
  },
  {
    id: "item-2",
    name: "Non-Veg Meal Combo",
    type: "Meal Combo",
    category: "NON-VEG",
    price: 1800,
    quantity: 1,
    selected: false,
  },

  // Starter
  {
    id: "item-3",
    name: "Cheese Sandwich",
    type: "Starter",
    category: "VEG",
    price: 500,
    quantity: 1,
    selected: false,
  },
  {
    id: "item-4",
    name: "Chicken Tikka",
    type: "Starter",
    category: "NON-VEG",
    price: 950,
    quantity: 1,
    selected: false,
  },

  // Main Course
  {
    id: "item-5",
    name: "Paneer Butter Masala",
    type: "Main Course",
    category: "VEG",
    price: 800,
    quantity: 1,
    selected: false,
  },

  // Decoration
  {
    id: "item-6",
    name: "Balloon Decoration",
    type: "Decoration",
    category: "DECO",
    price: 4000,
    quantity: 1,
    selected: false,
  },

  // Entertainment
  {
    id: "item-7",
    name: "DJ Music",
    type: "Entertainment",
    category: "FUN",
    price: 5000,
    quantity: 1,
    selected: false,
  },

  // Photographer
  {
    id: "item-8",
    name: "Basic Photography",
    type: "Photographer",
    category: "PRO",
    price: 3000,
    quantity: 1,
    selected: false,
  },
];

const MAX_ADDON_QTY = 10;

const clampQuantity = (value) =>
  Math.min(MAX_ADDON_QTY, Math.max(0, Number(value) || 0));

const Addons = () => {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);

 
  const [activeFilter, setActiveFilter] = useState("Meal Combo");
  const [filterTabs, setFilterTabs] = useState(filters);
  const [items, setItems] = useState(initialItems);

  useEffect(() => {
    const savedAddons = JSON.parse(localStorage.getItem("selectedAddons")) || [];

    const applySaved = (list) =>
      list.map((item) => {
        const found = savedAddons.find((addon) => addon.id === item.id);

        if (found) {
          return {
            ...item,
            selected: true,
            quantity: clampQuantity(found.quantity),
          };
        }

        return item;
      });

    const loadAddons = async () => {
      try {
        const response = await fetch("/api/addons");
        const groups = response.ok ? await response.json() : [];

        if (Array.isArray(groups) && groups.length > 0) {
          const tabs = groups.map((group) => group.name).filter(Boolean);
          const mapped = groups.flatMap((group) =>
            (group.items || []).map((item) => ({
              id: String(item._id),
              name: item.name,
              type: group.name,
              category: item.tag || "",
              price: Number(item.price) || 0,
              quantity: 1,
              selected: false,
            }))
          );

          setFilterTabs(tabs);
          setActiveFilter((previous) =>
            tabs.includes(previous) ? previous : tabs[0]
          );
          setItems(applySaved(mapped));
          return;
        }
      } catch (error) {
        console.error("Addons fetch error:", error);
      }

      setItems(applySaved(initialItems));
    };

    loadAddons();
  }, []);

const saveToLocal = (items) => {
  const selectedItems = items.filter(
    item => item.selected && item.quantity > 0
  );

  localStorage.setItem("selectedAddons", JSON.stringify(selectedItems));
};
  // quantity update
 const updateQuantity = (id, action) => {
  setItems((prev) => {
    const updated = prev.map((item) => {
      if (item.id === id) {
        let qty = item.quantity;
        if (action === "increment") qty = Math.min(MAX_ADDON_QTY, qty + 1);
        if (action === "decrement" && qty > 0) qty--;
        return { ...item, quantity: qty };
      }
      return item;
    });

    saveToLocal(updated);
    return updated;
  });
};


  // manual input change
  const handleInputChange = (id, value) => {
  const val = clampQuantity(value);

  setItems((prev) => {
    const updated = prev.map((item) =>
      item.id === id ? { ...item, quantity: val } : item
    );

    saveToLocal(updated); // ✅ ADD THIS
    return updated;
  });
};


  // checkbox toggle
const toggleCheckbox = (id) => {
  setItems((prev) => {
    const updated = prev.map((item) =>
      item.id === id ? { ...item, selected: !item.selected } : item
    );

    saveToLocal(updated); // ✅ ADD THIS
    return updated;
  });
};

  

  // ✅ Load cart
  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("cart")) || [];

    if (!Array.isArray(data)) {
      data = [data];
    }

    setCartItems(data);
  }, []);

  // ✅ DELETE SINGLE ITEM
const handleDelete = (index) => {
  const updatedCart = cartItems.filter((_, i) => i !== index);

  setCartItems(updatedCart);
  localStorage.setItem("cart", JSON.stringify(updatedCart));
};

  
 

  // ✅ Base total
  const baseTotal = cartItems.reduce(
    (sum, item) => sum + (item.price || 0),
    0
  );

  // ✅ Addon total
  
  const addonTotal = items.reduce((total, item) => {
  if (item.selected && item.quantity > 0) {
    return total + item.price * item.quantity;
  }
  return total;
}, 0);
  const finalTotal = baseTotal + addonTotal;

  // ✅ Proceed
const handleProceed = () => {
  const selectedItems = items.filter(
    item => item.selected && item.quantity > 0
  );

  // ✅ ALWAYS overwrite
  localStorage.setItem("selectedAddons", JSON.stringify(selectedItems));

  navigate("/confirmbooking");
};


  // ✅ Empty
  if (cartItems.length === 0) {
    return <h3 style={{ textAlign: "center" }}>No Data Found</h3>;
  }
const filteredItems = items.filter(
  item => item.type === activeFilter
);

const handleAddPackages = () => {
  const selectedItems = items.filter(
    item => item.selected && item.quantity > 0
  );

  

  // ✅ Save to localStorage
  localStorage.setItem("selectedAddons", JSON.stringify(selectedItems));

  // 👉 OPTIONAL: go to confirm page
  navigate("/confirmbooking");
};




  return (
    <>
      {/* <Header /> */}
      <IndiaBoatsTopBar />
      <PremiumNavbar />

      <section className="attractive-addons-container">
        <div className="attractive-main-content">

          {/* HEADER */}
         {/* HEADER */}
<div className="attractive-yacht-header">

{cartItems.map((item, index) => (
  <div key={index} className="attractive-yacht-info-group">

    {/* IMAGE + NAME */}
    <div className="attractive-yacht-info-block">
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={item.image || "assets/img/boat1.jpg"}
          className="attractive-yacht-header-img"
          alt="boat"
        />

        <div style={{ marginLeft: 15 }}>
          <div className="attractive-yacht-header-name">
            {item.boatName}
          </div>
          <div className="attractive-yacht-header-sublabel">
            SAILING
          </div>
        </div>
      </div>
    </div>

    {/* TIME */}
    <div className="attractive-yacht-info-block">
      <div className="attractive-yacht-header-detail-label">
        Time Slot & Day
      </div>
      <div className="attractive-yacht-header-detail-value">
        {item.time} |{" "}
        {item.date
          ? new Date(item.date).toLocaleDateString("en-GB")
          : ""}
      </div>
    </div>

    {/* LOCATION */}
    <div className="attractive-yacht-info-block">
      <div className="attractive-yacht-header-detail-label">
        Location
      </div>
      <div className="attractive-yacht-header-detail-value">
        {item.location}
      </div>
    </div>

    {/* PRICE */}
    <div className="attractive-yacht-info-block">
      <div className="attractive-yacht-header-detail-label">
        Base Price
      </div>
      <div className="attractive-yacht-header-detail-value">
        ₹ {item.price}
      </div>
    </div>

    {/* DELETE BUTTON */}
    <div className="attractive-yacht-info-block" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <button
        type="button"
        className="cart-action-button delete-icon"
        onClick={() => handleDelete(index)}
        title="Remove item"
      >
        <i className="fas fa-trash-alt" />
      </button>
    </div>

  </div>
))}

</div>


        <div className="attractive-addons-details-section">
          {/* Filters */}
          <h3 className="attractive-sidebar-heading">Select Add-Ons</h3>
          <div className="attractive-addons-filters">
            {filterTabs.map((filter) => (
              <button
                key={filter}
                className={`attractive-filter-btn ${
                  activeFilter === filter ? "active" : ""
                }`}
                onClick={() => setActiveFilter(filter)}
              >
                {filter}
              </button>
            ))}
          </div>

          {/* Table */}
         <table className="attractive-addons-table">
            <thead>
              <tr>
                <th className="col-item-name">Item Name & Category</th>
                <th className="col-item-price">Price (Rs)</th>
                <th className="col-item-quantity">Quantity</th>
                <th className="col-item-select">Select</th>
              </tr>
            </thead>

            <tbody>
              {filteredItems.map((item) => (
                <tr key={item.id}>
                  <td
                    className="col-item-name"
                    data-label="Item Name & Category"
                  >
                    {item.name}
                    {item.category ? (
                    <span
                      className={`item-category-tag ${
                        item.category === "VEG"
                          ? "tag-veg"
                          : item.category === "NON-VEG"
                          ? "tag-nonveg"
                          : "tag-deco"
                      }`}
                    >
                      {item.category}
                    </span>
                    ) : null}
                  </td>

                  <td className="col-item-price" data-label="Price">
                    {item.price}
                  </td>

                  <td className="col-item-quantity" data-label="Quantity">
                    <div className="attractive-quantity-control">
                      <button
                        className="attractive-quantity-btn"
                        onClick={() =>
                          updateQuantity(item.id, "decrement")
                        }
                      >
                        -
                      </button>

                      <input
                        type="number"
                        value={item.quantity}
                        min="0"
                        max={MAX_ADDON_QTY}
                        className="attractive-quantity-input"
                        onChange={(e) =>
                          handleInputChange(item.id, e.target.value)
                        }
                      />

                      <button
                        className="attractive-quantity-btn"
                        disabled={item.quantity >= MAX_ADDON_QTY}
                        onClick={() =>
                          updateQuantity(item.id, "increment")
                        }
                      >
                        +
                      </button>
                    </div>
                  </td>

                  <td className="col-item-select" data-label="Select">
                    <input
                      type="checkbox"
                      className="attractive-item-checkbox"
                      checked={item.selected}
                      onChange={() => toggleCheckbox(item.id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Footer */}
          {/* <div className="addon-action-footer">
            <button className="add-package-btn">
              Add Selected Packages
            </button>
          </div> */}
        </div>
    
          {/* ADDONS */}
          <div
        className="attractive-addons-toggle-bar"
        //onClick={handleToggle}
      >
        {/* <h3>
          Add-Ons (Optional)
          <span className="attractive-toggle-icon">
            {isOpen ? "x" : "+"}
          </span>
        </h3> */}

        <a onClick={handleProceed} className="attractive-proceed-btn ">
          Proceed to Checkout
        </a>
      </div>

      

          {/* TOTAL */}
         {/* <div className="addons-prices">
  <p className="addons_below_price">Base Total: ₹{baseTotal}</p>
  <p className="addons_below_price">Addons: ₹{addonTotal}</p>
  <p className="addons_below_price">Total Price: ₹{finalTotal}</p>
</div> */}

        
        </div>

        {/* SIDEBAR */}
        <div className="attractive-customer-sidebar">
          <h4 className="attractive-sidebar-heading">Customer Care</h4>

          <p className="attractive-sidebar-note">
            Need assistance or have a special request?
          </p>

          <div className="attractive-contact-detail">
            <span><Phone size={18} /> Call/WhatsApp:</span>
            <span>+91 7977600563</span>
            <span>+91 9004013301</span>
          </div>

          <div className="attractive-contact-detail">
            <span><Mail size={18} /> Email:</span>
            <span>customercare@indiaboats.in</span>
          </div>

          <p className="attractive-sidebar-note">
            We are available 24/7 to help you.
          </p>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Addons;
